import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Anurag from '../Assets/OurTeam/anurag-choubey.webp'
import Kavita from '../Assets/OurTeam/kavita-burse.webp'
import Nishchal from '../Assets/OurTeam/nishchal-kaushal.webp'
import ShashiJain from '../Assets/OurTeam/shashi-kumar-jain.webp'
import Sanjay from '../Assets/OurTeam/director_excellence.webp'
import VikasG from '../Assets/OurTeam/vikas-gupta.webp'
import Sanjeev from '../Assets/OurTeam/sanjeev-sharma.webp'
import BkDubey from '../Assets/OurTeam/bk-dubey.webp'
import Alka from '../Assets/OurTeam/alka-awasthi.webp'





const people = [
  {
    name: "Dr. Anurag Choubey",
    img: Anurag,
    des: "Group Director- Admin Ph.D in Computer Application from RGPV",
  },
  {
    name: "Dr. Kavita Burse",
    img: Kavita,
    des: "Director - Corporate Relations, B.Tech. from SGSITS, M.Tech, Ph.D from NIT, BHOPAl",
  },
  {
    name: "Prof. Nishchal Kaushal",
    img: Nishchal,
    des: " Addl. Director. Corporate Relations Director: Corporate Training | B Tech-NIT, M Tech-NIT Bhopal Ex: Daewoo,&nbsp;Ex-Honda",
  },
  {
    name: "Dr. Shashi Kumar Jain",
    img: ShashiJain,
    des: "Director Technocrats Institute of Technology, M.Tech. Ph.D in Mechanical Engineering",
  },
  {
    name: "Dr. Sanjay Sharma",
    img: Sanjay,
    des: "Director Technocrats Institute of Technology (Excellence), B.E., M.Tech., Ph.D.",
  },
  {
    name: "Dr. Vikas Gupta",
    img: VikasG,
    des: "Director Technocrats Institute of Technology and Science, B. E. , M. Tech , Ph.D.",
  },
  {
    name: "Dr. Sanjeev Sharma",
    img: Sanjeev,
    des: "Director Technocrats Institute of Technology- CSE, Associate NCC Officer M.Tech, Ph. D",
  },
  {
    name: "Dr. B.K. Dubey",
    img: BkDubey,
    des: "Director Technocrats Institute of Technology Pharmacy, Ph.D in Pharmacy",
  },
  {
    name: "Dr. Alka Awasthi",
    img: Alka,
    des: "Director Technocrats Institute of Technology - MBA, MBA, MA (Economics) PhD (Management)",
  },
  {
    name: "Dr. Anurag Choubey",
    img: Anurag,
    des: "Group Computer Application from RGPV",
  },

];

const OurTeam = () => {
  const responsive = {
    superLargeDesktop: {

      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <div id="OurTeam" className="ourteam">
    <p className="team-para">Your College Journey, Our Commitment: Get to Know the Team Shaping Your Future</p>
      <h1>OUR TEAM</h1>
      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlay
        autoPlaySpeed={3000}
        keyBoardControl={true}
        transitionDuration={1000}
      >
        {people.map((d) => (
          <div className="team-hero">
            <div className="team-containor">
              <div className="team-img">
                <img src={d.img} alt="" />
              </div>
              <div className="team-des">
                <h2>{d.name}</h2>
                <p>{d.des}</p>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
      
    </div>
  );
};

export default OurTeam;
